<template>
  <div class="home_container">
    <div class="home_container_inner_overall_situation ZHIHUISHU_QZMD" @click="gotoPage(2)">教师平台</div>
    <div class="home_container_inner_adminlogin ZHIHUISHU_QZMD" @click="gotoPage(1)">客户端下载</div>
    <div class="home_container_inner_logo">
      <img src="https://image.zhihuishu.com/zhs/ablecommons/zhangying/202112/4f022b3ff0514729890c7d9033b308ad.png" />
    </div>
    <div class="body_box">
      <div class="title_container">
        <img src="../assets/img/login-logo.png" alt="" />
        同步课堂网-真正的教室互联网
      </div>
      <div class="school_type">
        <div>机构类型</div>
        <div>
          高等院校
          <img src="../assets/img/right-arrow3.png" alt="" />
        </div>
      </div>
      <div class="home_container_inner_box">
        <a-tabs :tabBarGutter="0" :animated="false" v-show="!isForget">
          <a-tab-pane key="1" tab="手机登录">
            <div class="login_box">
              <div class="phone_num">
                <div>
                  <span>+86</span>
                  <span>|</span>
                </div>
                <a-input v-model="box1.phoneNum" placeholder="请输入手机号" />
              </div>
              <div class="password">
                <a-input v-model="box1.password" type="password" placeholder="请输入密码" @keyup.enter="box1Login" />
              </div>
              <div class="forgot_password" @click="isForget = true">忘记密码</div>
              <div
                class="login_btn"
                :class="{
                  login_btn_disable: box1.phoneNum.length == 0 || box1.password.length == 0
                }"
                @click="box1Login"
              >
                登录
              </div>
              <div class="tips">*若已有智慧树、知到账号均可登录*</div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="短信登录">
            <div class="login_box">
              <div class="phone_num">
                <div>
                  <span>+86</span>
                  <span>|</span>
                </div>
                <a-input v-model="box2.phoneNum" placeholder="请输入手机号" />
              </div>
              <div class="password">
                <a-input v-model="box2.code" placeholder="请输入验证码" />
                <div class="get_code" @click="sendValidCode(2)" v-show="!box2Coding">获取验证码</div>
                <div class="reget_code" v-show="box2Coding">重新获取({{ box2CodingNum }})</div>
              </div>
              <div class="forgot_password" @click="isForget = true">忘记密码</div>
              <div
                class="login_btn"
                :class="{
                  login_btn_disable: box2.phoneNum.length == 0 || box2.code.length == 0
                }"
                @click="box2Login"
              >
                登录
              </div>
              <div class="tips">*若已有智慧树、知到账号均可登录*</div>
            </div>
          </a-tab-pane>
        </a-tabs>
        <div v-show="isForget" class="forget_box">
          <h3>找回密码</h3>
          <div class="phone_num">
            <div>
              <span>+86</span>
              <span>|</span>
            </div>
            <a-input v-model="box3.phoneNum" placeholder="请输入手机号" />
          </div>
          <div class="password">
            <a-input v-model="box3.code" placeholder="请输入验证码" />
            <div class="get_code" @click="sendValidCode(3)" v-show="!box3Coding">获取验证码</div>
            <div class="reget_code" v-show="box3Coding">重新获取({{ box3CodingNum }})</div>
          </div>
          <div class="password">
            <a-input type="password" v-model="box3.password" placeholder="设置新密码" />
          </div>
          <div class="password">
            <a-input type="password" v-model="box3.rePassword" placeholder="请再输入一次密码" />
          </div>
          <div class="tips">8-16位，同时包含小写字母、大写字母和数字</div>
          <div
            class="login_btn"
            :class="{
              login_btn_disable:
                box3.phoneNum.length == 0 ||
                box3.code.length == 0 ||
                box3.password.length == 0 ||
                box3.rePassword.length == 0
            }"
            @click="box3Confirm"
          >
            确定
          </div>
          <div class="return" @click="isForget = false">返回密码登录</div>
        </div>
      </div>
    </div>
    <div class="html_type">管理中心 | 网页版</div>
    <div class="mark">2022 智慧树 京ICP备14D19655号 | 京公网安备11010802033052号</div>

    <div class="broswer_hint_container" v-if="flagForBroswerHint">
      <div class="broswer_hint_container_inner">
        <div class="broswer_hint_container_inner_title">
          <div class="broswer_hint_container_inner_title_logo">
            <img src="../assets/img/chrome.png" alt="chrome" />
          </div>
          <div class="broswer_hint_container_inner_title_text">CHROME安装指南</div>
        </div>
        <div class="broswer_hint_container_inner_body">
          <div class="broswer_hint_container_inner_body_title">系统需使用Chrome浏览器</div>
          <div class="broswer_hint_container_inner_body_body">
            若已安装Chrome请使用Chrome浏览器，若未安装Chrome请先下载
          </div>
          <div class="broswer_hint_container_inner_body_footer">
            <div class="broswer_hint_container_inner_body_footer_btn" @click="downloadChrome">下载Chrome</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { getBroswer } from '../utils/tool'
export default {
  data() {
    return {
      box1: {
        phoneNum: '',
        password: ''
      },
      box2: {
        phoneNum: '',
        code: ''
      },
      box3: {
        phoneNum: '',
        code: '',
        password: '',
        rePassword: ''
      },
      isForget: false,
      box2Coding: false,
      box2CodingNum: 60,
      box3Coding: false,
      box3CodingNum: 60,
      box2Interval: 0,
      // 浏览器弹框：
      flagForBroswerHint: false
    }
  },
  created() {
    // console.log(getBroswer().browser.chrome, 'getBroswer_is_chrome')
    if (!getBroswer().browser.chrome) {
      this.flagForBroswerHint = true
    } else {
      this.flagForBroswerHint = false
    }
  },
  mounted() {
    let box2Time = localStorage.getItem('login_box2_codeTime')
    if (
      box2Time &&
      new Date().getTime() - Number(box2Time) < 60 * 1000 &&
      new Date().getTime() - Number(box2Time) > 0
    ) {
      this.box2Coding = true
      this.box2CodingNum = 60 - ((new Date().getTime() - Number(box2Time)) / 1000).toFixed(0)
      this.box2Interval = setInterval(() => {
        this.box2CodingNum -= 1
        if (this.box2CodingNum == 0) {
          clearInterval(this.box2Interval)
          this.box2Coding = false
          this.box2CodingNum = 60
        }
      }, 1000)
    }
    let box3Time = localStorage.getItem('login_box3_codeTime')
    if (
      box3Time &&
      new Date().getTime() - Number(box3Time) < 60 * 1000 &&
      new Date().getTime() - Number(box3Time) > 0
    ) {
      this.box3Coding = true
      this.box3CodingNum = 60 - ((new Date().getTime() - Number(box3Time)) / 1000).toFixed(0)
      this.box3Interval = setInterval(() => {
        this.box3CodingNum -= 1
        if (this.box3CodingNum == 0) {
          clearInterval(this.box3Interval)
          this.box3Coding = false
          this.box3CodingNum = 60
        }
      }, 1000)
    }
  },
  methods: {
    ...mapMutations('userInfo', {
      Mutation_SET_TOKEN: 'Mutation_SET_TOKEN'
    }),
    gotoPage(status) {
      if (status == 1) {
        // window.open('https://www.zhihuishu.com/DownloadApp.html')
        window.open('https://www.livecourse.com/teacher/downloadLiveCourseClient')
      } else if (status == 2) {
        window.open('https://www.livecourse.com/teacher/Home')
      }
    },
    async box1Login() {
      if (this.box1.phoneNum.trim().length == 0 || this.box1.password.trim().length == 0) return
      let regx = /^1\d{10}$/
      if (!regx.test(this.box1.phoneNum.trim())) {
        return this.$message.warning('请输入正确的手机号!')
      }
      let res = await this.$api.phoneLogin({
        phone: this.box1.phoneNum.trim(),
        password: this.box1.password.trim()
      })
      if (res.code == 200) {
        if (res.rt.resultStatus == -1) {
          return this.$message.error(res.rt.resultMessage)
        }
        this.Mutation_SET_TOKEN(res.rt)
        this.$message.success('登录成功')
        setTimeout(() => {
          this.$router.push('/')
        }, 500)
      }
    },
    async box2Login() {
      if (this.box2.phoneNum.trim().length == 0 || this.box2.code.trim().length == 0) return
      let regx = /^1\d{10}$/
      if (!regx.test(this.box2.phoneNum.trim())) {
        return this.$message.warning('请输入正确的手机号!')
      }
      let res = await this.$api.phoneLogin({
        phone: this.box2.phoneNum.trim(),
        code: this.box2.code.trim()
      })
      if (res.code == 200) {
        if (res.rt.resultStatus == -1) {
          return this.$message.error(res.rt.resultMessage)
        }
        this.Mutation_SET_TOKEN(res.rt)
        this.$message.success('登录成功')
        setTimeout(() => {
          this.$router.push('/')
        }, 500)
      }
    },
    async sendValidCode(index) {
      let regx = /^1\d{10}$/
      let phoneNum = ''
      // 短信登录
      if (index == 2) {
        if (!regx.test(this.box2.phoneNum)) {
          return this.$message.warning('请输入正确的手机号!')
        }
        if (this.box2Coding) return
        phoneNum = this.box2.phoneNum
      } else if (index == 3) {
        // 找回密码
        if (!regx.test(this.box3.phoneNum)) {
          return this.$message.warning('请输入正确的手机号!')
        }
        if (this.box3Coding) return
        phoneNum = this.box3.phoneNum
      }
      let res = await this.$http.sendValidCode({
        phone: phoneNum
      })
      if (res.code == 200 && res.rt.resultStatus == -1) {
        return this.$message.error(res.rt.resultMessage)
      }
      if (res.code == 200 && res.rt.resultStatus == 1) {
        if (index == 2) {
          this.box2Coding = true
          localStorage.setItem('login_box2_codeTime', new Date().getTime())
          this.box2Interval = setInterval(() => {
            this.box2CodingNum -= 1
            if (this.box2CodingNum == 0) {
              clearInterval(this.box2Interval)
              this.box2Coding = false
              this.box2CodingNum = 60
            }
          }, 1000)
        } else if (index == 3) {
          this.box3Coding = true
          localStorage.setItem('login_box3_codeTime', new Date().getTime())
          this.box3Interval = setInterval(() => {
            this.box3CodingNum -= 1
            if (this.box3CodingNum == 0) {
              clearInterval(this.box3Interval)
              this.box3Coding = false
              this.box3CodingNum = 60
            }
          }, 1000)
        }
      }
    },
    async box3Confirm() {
      if (
        this.box3.phoneNum.trim().length == 0 ||
        this.box3.code.trim().length == 0 ||
        this.box3.password.trim().length == 0 ||
        this.box3.rePassword.trim().length == 0
      )
        return
      let regx = /^1\d{10}$/
      if (!regx.test(this.box3.phoneNum.trim())) {
        return this.$message.warning('请输入正确的手机号!')
      }
      let regp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/
      if (!regp.test(this.box3.password)) {
        return this.$message.warning('密码需包含大小写字母及数字，长度在8-16位!')
      }
      if (this.box3.password.trim() != this.box3.rePassword.trim()) {
        return this.$message.warning('请保持密码一致!')
      }
      let res = await this.$http.updatePhonePassword({
        phone: this.box3.phoneNum.trim(),
        code: this.box3.code.trim(),
        newPassword: this.box3.password.trim()
      })
      if (res.code == 200 && res.rt.resultStatus == -1) {
        return this.$message.error(res.rt.resultMessage)
      }
      if (res.code == 200 && res.rt.resultStatus == 1) {
        this.$message.success('密码重置成功!')
        setTimeout(() => {
          this.isForget = false
        }, 200)
      }
    },
    downloadChrome() {
      window.open('https://www.google.cn/chrome/', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin verticalAndCrosswiseCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
.home_container {
  width: 100%;
  height: 100vh;
  background-image: url(https://image.zhihuishu.com/zhs/ablecommons/zhangying/202112/260c1adee27a42c5b907d3f0db6be427.png);
  background-size: cover;
  position: relative;
  .html_type {
    position: absolute;
    left: 32px;
    bottom: 20px;
    font-size: 15px;
    font-family:
      PingFangSC-Medium,
      PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 21px;
    text-shadow: 0px 2px 4px #556632;
  }
  .mark {
    position: absolute;
    right: 32px;
    bottom: 20px;
    font-size: 15px;
    font-family:
      PingFangSC-Medium,
      PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 21px;
    text-shadow: 0px 2px 4px rgba(11, 29, 42, 0.5);
  }
  .home_container_inner_overall_situation,
  .home_container_inner_adminlogin {
    width: 138px;
    height: 44px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 22px;
    font-size: 16px;
    font-family:
      PingFangSC-Medium,
      PingFang SC;
    font-weight: 500;
    color: #ffffff;
    position: absolute;
    top: 32px;
    z-index: 2;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
  }
  .home_container_inner_overall_situation {
    right: 32px;
    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
    &:active {
      background-color: transparent;
    }
  }
  .home_container_inner_adminlogin {
    right: 186px;
    background-color: #5f60d3;
    &:hover {
      background-color: #4749b3;
    }
    &:active {
      background-color: #5f60d3;
    }
  }
  .home_container_inner_logo {
    width: 150px;
    position: absolute;
    left: 60px;
    top: 32px;
    z-index: 2;
    img {
      width: 100%;
    }
  }
  .body_box {
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .forget_box {
      h3 {
        margin-top: 12px;
        text-align: center;
        font-size: 16px;
        font-family:
          PingFangSC-Medium,
          PingFang SC;
        font-weight: 500;
        color: #041633;
      }
      .phone_num,
      .password {
        width: 279px;
        height: 44px;
        background: #f3f8ff;
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin-left: 16px;
        margin-top: 16px;
        > input {
          border: none;
          background: #f3f8ff;
          height: 44px;
        }
        input:-webkit-autofill {
          box-shadow: 0 0 0px 1000px #f3f8ff inset !important;
          /* -webkit-text-fill-color: #fff !important;   //字体颜色 */
        }
      }
      .phone_num {
        margin-top: 8px;
        > div:nth-child(1) {
          width: 66px;
          height: 20px;
          font-size: 14px;
          font-family:
            PingFangSC-Regular,
            PingFang SC;
          font-weight: 400;
          color: #041633;
          line-height: 20px;
          padding-left: 16px;
          > span:nth-child(2) {
            margin-left: 12px;
          }
        }
      }
      .password {
        .get_code {
          width: 106px;
          font-size: 14px;
          font-family:
            PingFangSC-Regular,
            PingFang SC;
          font-weight: 400;
          color: #3982ff;
          cursor: pointer;
          margin-right: 16px;
        }
        .reget_code {
          width: 122px;
          font-size: 14px;
          font-family:
            PingFangSC-Regular,
            PingFang SC;
          font-weight: 400;
          color: #9fa2b1;
        }
      }
      .tips {
        margin-top: 24px;
        text-align: center;
        font-size: 12px;
        font-family:
          PingFangSC-Regular,
          PingFang SC;
        font-weight: 400;
        color: #f2b255;
      }
      .login_btn {
        @include verticalAndCrosswiseCenter();
        width: 279px;
        height: 44px;
        background: #5f60d3;
        border-radius: 8px;
        font-size: 16px;
        font-family:
          PingFangSC-Medium,
          PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 22px;
        margin-left: 16px;
        margin-top: 8px;
        margin-bottom: 11px;
        cursor: pointer;
        user-select: none;
        &:active {
          background: rgba(95, 96, 211, 0.9);
        }
      }
      .login_btn_disable {
        background: #b8bbc7;
        &:active {
          background: #b8bbc7;
        }
      }
      .return {
        text-align: center;
        font-size: 16px;
        font-family:
          PingFangSC-Regular,
          PingFang SC;
        font-weight: 400;
        color: #3982ff;
        margin-bottom: 27px;
        cursor: pointer;
      }
    }
    .login_box {
      .phone_num,
      .password {
        width: 279px;
        height: 44px;
        background: #f3f8ff;
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin-left: 16px;
        margin-top: 16px;
        > input {
          border: none;
          background: #f3f8ff;
          height: 44px;
        }
        input:-webkit-autofill {
          box-shadow: 0 0 0px 1000px #f3f8ff inset !important;
          /* -webkit-text-fill-color: #fff !important;   //字体颜色 */
        }
      }
      .phone_num {
        margin-top: 8px;
        > div:nth-child(1) {
          width: 66px;
          height: 20px;
          font-size: 14px;
          font-family:
            PingFangSC-Regular,
            PingFang SC;
          font-weight: 400;
          color: #041633;
          line-height: 20px;
          padding-left: 16px;
          > span:nth-child(2) {
            margin-left: 12px;
          }
        }
      }
      .password {
        .get_code {
          width: 106px;
          font-size: 14px;
          font-family:
            PingFangSC-Regular,
            PingFang SC;
          font-weight: 400;
          color: #3982ff;
          cursor: pointer;
          margin-right: 16px;
        }
        .reget_code {
          width: 122px;
          font-size: 14px;
          font-family:
            PingFangSC-Regular,
            PingFang SC;
          font-weight: 400;
          color: #9fa2b1;
        }
      }
      .forgot_password {
        display: flex;
        justify-content: right;
        height: 20px;
        font-size: 14px;
        font-family:
          PingFangSC-Regular,
          PingFang SC;
        font-weight: 400;
        color: #9fa2b1;
        line-height: 20px;
        margin-right: 16px;
        margin-top: 8px;
        cursor: pointer;
      }
      .login_btn {
        @include verticalAndCrosswiseCenter();
        width: 279px;
        height: 44px;
        background: #5f60d3;
        border-radius: 8px;
        font-size: 16px;
        font-family:
          PingFangSC-Medium,
          PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 22px;
        margin-left: 16px;
        margin-top: 24px;
        cursor: pointer;
        user-select: none;
        &:active {
          background: rgba(95, 96, 211, 0.9);
        }
      }
      .login_btn_disable {
        background: #b8bbc7;
        &:active {
          background: #b8bbc7;
        }
      }
      .tips {
        @include verticalAndCrosswiseCenter();
        height: 17px;
        font-size: 12px;
        font-family:
          PingFangSC-Regular,
          PingFang SC;
        font-weight: 400;
        color: #9fa2b1;
        margin-top: 16px;
      }
    }
    .title_container {
      width: 390px;
      height: 36px;
      font-size: 24px;
      font-family:
        PingFangSC-Medium,
        PingFang SC;
      font-weight: 500;
      color: #ffffff;
      margin-bottom: 37px;
      img {
        width: 36px;
        height: 36px;
        margin-right: 16px;
      }
    }
    .school_type {
      font-size: 14px;
      font-family:
        PingFangSC-Regular,
        PingFang SC;
      font-weight: 400;
      color: #ffffff;
      width: 311px;
      height: 38px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 4px;
      border: 1px solid #5f60d3;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      margin-bottom: 36px;
      opacity: 0.8;
      > div {
        @include verticalAndCrosswiseCenter();
        img {
          width: 12px;
          height: 12px;
          vertical-align: center;
          margin-left: 8px;
        }
      }
    }
    .home_container_inner_box {
      width: 311px;
      min-height: 368px;
      background: #ffffff;
      border-radius: 8px;
      /* animation: scaleToShow 0.3s ease-in 1 alternate forwards; */
      text-align: left;
      padding-top: 20px;
      ::v-deep .ant-tabs-bar {
        padding: 0 16px;
        border-bottom: none;
      }
      ::v-deep .ant-tabs-nav-container {
        border-bottom: 1px solid #e8e8e8;
      }
      ::v-deep.ant-tabs-tab {
        font-size: 14px;
        font-family:
          PingFangSC-Regular,
          PingFang SC;
        font-weight: 400;
        color: #9097ad;
      }
      ::v-deep.ant-tabs-ink-bar {
        background-color: #5f60d3;
      }
      ::v-deep.ant-tabs-tab-active {
        font-size: 14px;
        font-family:
          PingFangSC-Medium,
          PingFang SC;
        font-weight: 500;
        color: #5f60d3;
        &::selection {
          background: #5f60d3;
        }
      }
    }
  }
}
@keyframes scaleToShow {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}
.broswer_hint_container {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  text-align: left;
  .broswer_hint_container_inner {
    width: 500px;
    height: 250px;
    background-color: #fff;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    .broswer_hint_container_inner_title {
      width: 100%;
      height: 60px;
      border-bottom: 2px solid #f8f9fa;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #5c5e63;
      .broswer_hint_container_inner_title_logo {
        width: 40px;
        height: 40px;
        margin-right: 15px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .broswer_hint_container_inner_title_text {
        font-size: 20px;
        font-weight: bold;
      }
    }
    .broswer_hint_container_inner_body {
      flex: 1;
      width: 100%;
      .broswer_hint_container_inner_body_title {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        font-weight: bold;
        padding-left: 40px;
        position: relative;
        color: #525559;
        &::before {
          content: '';
          width: 3px;
          height: 18px;
          background-color: #6564a2;
          position: absolute;
          left: 30px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .broswer_hint_container_inner_body_body {
        font-size: 16px;
        color: #929699;
        padding: 0 100px 0 25px;
      }
      .broswer_hint_container_inner_body_footer {
        width: 100%;
        display: flex;
        justify-content: center;
        position: absolute;
        left: 0;
        bottom: 20px;
        .broswer_hint_container_inner_body_footer_btn {
          width: 130px;
          height: 50px;
          border: 1px solid #6564a2;
          color: #6564a2;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 5px;
          font-size: 16px;
          cursor: pointer;
          &:hover {
            background-color: #f5f5f5;
          }
          &:active {
            background-color: #fff;
          }
        }
      }
    }
  }
}
</style>
